import styled from 'styled-components';

export const ContainerGrid = styled.div`
  width: 100%;
  height: 100%;
  padding: 20px;

  .grid .hideRightSeparator .MuiDataGrid-columnSeparator {
    display: none;
  }
`;

export const ContainerAcoes = styled.div`
  width: 100px;
  height: 30px;
  display: grid;
  align-items: center;
  justify-content: center;
  justify-items: center;
  grid-template-columns: 1fr 1fr;
  gap: 5px;
  transition: all 0.5s;
  button {
    background: none;
    border: none;
    svg {
      font-size: 20pt;
    }
  }
`;

export const ContainerModal = styled.div`
  .modal-custom-border {
    border: 3px solid #ccc;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(88, 88, 88, 0.34);
  }
`;
